module.exports = __webpack_public_path__ + "img/minivan.c50f7780.png";